import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { HeaderComponent } from "./header/header.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { FooterComponent } from "./footer/footer.component";
import { Store } from "@ngrx/store";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { RootState } from "../../common/ngrx/root.model";

@UntilDestroy()
@Component({
  standalone: true,
  selector: "vig-layout",
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.scss",
  imports: [CommonModule, HeaderComponent, NavbarComponent, FooterComponent],
})
export class LayoutComponent implements OnInit {
  constructor(private store: Store<RootState>) {}

  _userLoggedIn = false;

  ngOnInit(): void {
    this.initializeStore();
  }

  initializeStore(): void {
    this.store.pipe(untilDestroyed(this)).subscribe((state: RootState) => {
      this._userLoggedIn = state.app.userLoggedIn;
    });
  }
}
